import { AccountField } from '../../../utils/forms';

const authFormLabel = {
  [AccountField.MOBILE]: 'Mobile number',
  [AccountField.TERMS]: 'Terms and conditions',
  [AccountField.VERIFICATION_CODE]: 'Your 6-digit code',
};

export default authFormLabel;
